import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Router } from '@angular/router';
import { BaseSubMaintenanceController } from "../../_base/BaseSubMaintenanceController";
import { PartnerKeyAlternativeItemMaintenanceDto } from "./PartnerKeyAlternativeItemMaintenanceDto";
import { PartnerKeyAlternativeListMaintenanceDto } from "./PartnerKeyAlternativeListMaintenanceDto";


@Injectable()
export class PartnerKeyAlternativeSubMaintenanceController extends BaseSubMaintenanceController<PartnerKeyAlternativeListMaintenanceDto, PartnerKeyAlternativeItemMaintenanceDto> {
    private base = '/partner/keyalternative'

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "partner/keyalternative");
    }

    public getResourceRoot(): string {
        return "PARTNER.KEYALTERNATIVE";
    }

    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return "/system/partner/all/" + parentId + "/" + optionParentid + "/submain" + uri;
    }
}